import * as AlignmentCornersRepainter from "./repainters/alignment-corners-repainter.js";
import * as DataPointsRepainter from "./repainters/data-points-repainter.js";
import * as MultipleDatasetRepainter from "./repainters/multiple-dataset-repainter.js";

/**
 * Initializes WPD repainters.
 */
function init(wpd, dataEntryVM) {
	AlignmentCornersRepainter.init(wpd);
	DataPointsRepainter.init(wpd, dataEntryVM);
	MultipleDatasetRepainter.init(wpd);
}

export { init };
